<template>
  <div class="poster">
    <div class="cover">
      <img src="@/assets/talent-banner.png" alt class="top-cover" />
    </div>
    <div class="warp">
      <van-form @submit="employ" validate-first>
        <van-cell-group class="wrap-cell-wrap">
          <van-field
            clickable
            required
            label="企业名称"
            placeholder="请填写企业名称"
            v-model="compname"
            :rules="[{ required: true, message: '请填写企业名称' }]"
          />
          <!-- <van-field clickable required label="所在城市" placeholder="请输入" v-model="itemext1" /> -->
          <van-field
            readonly
            clickable
            label="所在区域"
            v-model="itemext1"
            placeholder="请选择"
            required
            @click="selectWitchs()"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择' }]"
          />
          <van-field
            clickable
            required
            label="工种"
            placeholder="请填写工种"
            v-model="jobtype"
            :rules="[{ required: true, message: '请填写工种' }]"
          />
          <van-field
            clickable
            required
            type="tel"
            label="共享时长"
            placeholder="请填写需求时长"
            v-model="sharetime"
            :rules="[{ required: true, message: '请填写需求时长' }]"
          >
            <span slot="button" class="time-month">/月</span>
          </van-field>
          <van-field
            type="tel"
            clickable
            required
            label="共享人数"
            placeholder="请填写需求人数"
            v-model="needcount"
            :rules="[{ required: true, message: '请填写需求人数' }]"
          />
          <van-field
            clickable
            required
            type="tel"
            label="联系电话"
            placeholder="请填写联系电话"
            v-model="phonenum"
            :rules="[{ required: true, message: '请填写联系电话' }]"
          />
          <van-field
            clickable
            required
            label="联系人"
            placeholder="请填写联系人姓名"
            v-model="contacter"
            :rules="[{ required: true, message: '请填写联系人姓名' }]"
          />
        </van-cell-group>
        <!-- 地区选择 -->
        <van-popup v-model="showdiqu" position="bottom">
          <van-area
            v-model="itemext1"
            :area-list="areaList"
            @confirm="areaConfirm"
            @cancel="areaCancel"
          />
        </van-popup>
        <van-row class="buttonWarp">
          <div v-show="errorMess" class="errorMessage">{{txt}}</div>
          <!-- <van-button  @click="employ">提交</van-button> -->
          <van-button size="large" type="primary" class="button" plain native-type="submit">提交</van-button>
        </van-row>
      </van-form>
    </div>
  </div>
</template>
<script>
import { getAreass, getEmploy } from "../api/test";
export default {
  data() {
    return {
      errorMess: false,
      showdiqu: false, //开始地区弹框
      // isShowSubscripButton: true,
      // active: 0,
      // count: 0,
      // shareShow: false,
      // thirdChannelLogo:'',
      // showReport:false,
      // custName :"",
      // post :"",
      // toatl :"",
      // adress:"",
      // person:"",
      // phone:"",
      compname: "",
      itemext1: "",
      jobtype: "",
      worktime: "",
      needcount: "",
      phonenum: "",
      contacter: "",
      sharetime: "",
      areaList: {}, //地区
      cityCode: "",
      txt: ""
      // gender:"",
      // worktime:"",
      // phonenum:"",
      // idcard:"",
      // job:"",
      // ishrrecommend:"",
      // address:"",
      //  showPicker:false,
    };
  },
  created() {},
  mounted() {
    this.getAreas();
  },
  methods: {
    // selectWitch(){
    //   this.showPicker = true;
    // },
    // onConfirm(value) {
    //   this.phone= value;
    //   this.showPicker = false;
    // },
    selectWitchs() {
      this.showdiqu = true;
    },
    areaConfirm(val) {
      console.log(val);
      this.showdiqu = false;
      this.itemext1 = val[0].name + "" + val[1].name + val[2].name;
      this.cityCode = val[0].code;
    },
    areaCancel() {
      this.showdiqu = false;
    },
    getAreas() {
      var params = {};
      getAreass("/getArea", params).then(res => {
        this.areaList = eval("(" + res.data + ")");
      });
    },
    // 点击提交
    employ() {
      console.log("tag", "提交");
      var params = {
        compname: this.compname,
        itemext1: this.itemext1,
        jobtype: this.jobtype,
        sharetime: this.sharetime,
        needcount: this.needcount,
        phonenum: this.phonenum,
        contacter: this.contacter,
        itemcode: this.cityCode, // 地区编码
        workaddress: "",
        jobneed: ""
      };
      getEmploy("/flexibleCompany", params, {})
        .then(
          function(res) {
            console.log(res);
            if (res.msg == "请求成功") {
              this.$router.push({ path: "/UploadResult" });
              // let storages= window.localStorage;
              // let workerId = res.data;
              // storages.setItem('workerId',JSON.stringify(workerId));
            } else {
              this.errorMess = true;
              this.txt = res.msg;
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped lang='less'>
div {
  box-sizing: border-box;
}
.warp {
  width: 90%;
  background-color: #ffffff;
  margin: 0px 10px 0px 20px;
  // height: 59.5%;
  border-radius: 9px;
  padding-top: 10px;
  .wrap-cell-wrap {
    padding: 0 7px;
  }
  .wrap-cell-wrap::after {
    border-top: none;
  }
}
.buttonWarp {
  text-align: center;
  padding-bottom: 20px;
  background: #fff;
}
.button {
  width: 90%;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  // background-color: #1989fa;
  background-color: #4ac7a9;
  color: #fff;
  margin-top: 20px;
}
.poster {
  // background: linear-gradient(
  //   90deg,
  //   rgba(20, 50, 166, 1),
  //   rgba(13, 39, 150, 1)
  // );
  background: #fa743d;
  position: relative;
  width: 100%;
  height: 100%;
  .cover {
    width: 100%;
    position: relative;
    .top-cover {
      width: 100%;

      vertical-align: bottom;
      overflow: hidden;
    }
  }
}
.errorMessage {
  width: 100%;
  height: 30px;
  color: red;
  font-size: 14px;
  margin-bottom: -20px;
}
.time-month {
  font-size: 14px;
  font-family: PingFang SC;
  color: #323233;
}
/deep/.buttonWarp {
  border-radius: 9px;
}
</style>
